import { gql } from '@apollo/client'
import { useMutation } from 'src/services/apollo'
import { IUseMutationOptions } from 'src/services/apollo/Mutation/useMutation'
import {
  QualificationInstanceAttachmentUpdate,
  QualificationInstanceAttachmentUpdateVariables,
} from './__gql__/qualificationInstanceAttachmentUpdateCodeGen'

const QUALIFICATION_INSTANCE_ATTACHMENT_UPDATE = gql`
  mutation QualificationInstanceAttachmentUpdate(
    $documentId: ID!
    $uploadStatus: PersonDocumentUploadStatus
    $displayName: String
    $folderId: String
  ) {
    qualificationInstanceAttachmentUpdate(
      input: { documentId: $documentId, uploadStatus: $uploadStatus, displayName: $displayName, folderId: $folderId }
    ) {
      document {
        id
        uploadStatus
        displayName
        extension
        size
        humanReadableSize
        createdAtDateTime
        downloadUrlAbsolute
        personId
        folderId
        category
        createdAt
        downloadUrl
      }
    }
  }
`

const useQualificationInstanceAttachmentUpdate = (
  options?: IUseMutationOptions<QualificationInstanceAttachmentUpdate, QualificationInstanceAttachmentUpdateVariables>,
) => {
  return useMutation<QualificationInstanceAttachmentUpdate, QualificationInstanceAttachmentUpdateVariables>(
    QUALIFICATION_INSTANCE_ATTACHMENT_UPDATE,
    {
      ...options,
    },
  )
}

export { useQualificationInstanceAttachmentUpdate }
